/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Username_RequiredInputs */



/**

* @param {Username_RequiredInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const username_required = /** @type {((inputs?: Username_RequiredInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Username_RequiredInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Es muss ein Benutzername angegeben werden.")
});